export enum OtUserAction {
  Create = 'CREATE',
  View = 'VIEW',
  Edit = 'EDIT',
  Deactivate = 'DEACTIVATE',
  Reinvite = 'REINVITE',
  Invite = 'INVITE',
  Remove = 'REMOVE',
}
